import {
  type AnimationOption,
  AnimationWipeFunction,
  TileRotatePattern,
} from "@package/ui-gql/index-data-access";

export function createDefaultAnimationOption(
  typename: NonNullable<AnimationOption["__typename"]>,
): AnimationOption {
  switch (typename) {
    case "AnimationOptionFade": {
      return {
        __typename: "AnimationOptionFade",
        type: "fade",
        duration: 3,
      };
    }
    case "AnimationOptionFlip": {
      return {
        __typename: "AnimationOptionFlip",
        type: "flip",
        direction: TileRotatePattern.Horizontal,
        duration: 3,
      };
    }
    case "AnimationOptionWipe": {
      return {
        __typename: "AnimationOptionWipe",
        type: "wipe",
        duration: 3,
        function: AnimationWipeFunction.Down,
      };
    }
  }
}
